import { render } from "./WawaOne.vue?vue&type=template&id=55abe09e"
import script from "./WawaOne.vue?vue&type=script&lang=js"
export * from "./WawaOne.vue?vue&type=script&lang=js"

import "./WawaOne.vue?vue&type=style&index=0&id=55abe09e&lang=css"
script.render = render

export default script